import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { X, Loader2, Building2 } from "lucide-react";

export default function ContactModal({ open, onClose, defaultLocation = "" }) {
  const [form, setForm] = useState({ name: "", company: "", email: "", location: defaultLocation, message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  if (!open) return null;

  const submit = async () => {
    if (!form.name || !form.company || !form.email || !form.location) {
      toast.error("Please fill name, company, email and location"); return;
    }
    setSending(true);
    try { await api.contact(form); setDone(true); }
    catch { toast.error("Could not send — please try again"); }
    finally { setSending(false); }
  };

  const field = "w-full px-4 py-3 rounded-xl border border-[#E8E1D9] bg-white focus:outline-none focus:border-[#6B21A8] focus:ring-2 focus:ring-[#6B21A8]/15 transition";

  return (
    <div className="fixed inset-0 z-[60] bg-[#2B2625]/50 grid place-items-center px-5" data-testid="contact-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-7 shadow-xl relative">
        <button onClick={onClose} data-testid="contact-close" className="absolute top-4 right-4 text-[#918780] hover:text-[#2B2625]"><X size={20} /></button>
        {done ? (
          <div className="text-center py-6">
            <span className="w-14 h-14 rounded-2xl bg-[#F2E9FA] text-[#3F3A44] grid place-items-center mx-auto mb-4"><Building2 size={26} /></span>
            <h3 className="font-display text-2xl font-bold text-[#2B2625] mb-2">Thank you!</h3>
            <p className="text-[#6E655F]">We've received your request for a larger team and will be in touch shortly.</p>
            <button onClick={onClose} className="mt-6 bg-[#6B21A8] text-white font-semibold py-2.5 px-6 rounded-xl">Close</button>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 text-[#6B21A8] font-semibold mb-1"><Building2 size={18} /> Larger team?</div>
            <h3 className="font-display text-2xl font-bold text-[#2B2625] mb-1">Let's set you up</h3>
            <p className="text-[#6E655F] text-sm mb-5">For teams larger than 5, share a few details and we'll craft the right plan for you.</p>
            <div className="space-y-3">
              <input data-testid="contact-name" className={field} placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input data-testid="contact-company" className={field} placeholder="Company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
              <input data-testid="contact-email" type="email" className={field} placeholder="Work email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input data-testid="contact-location" className={field} placeholder="Location" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />
              <textarea data-testid="contact-message" className={field} rows={2} placeholder="How big is your team? (optional)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            </div>
            <button data-testid="contact-submit" onClick={submit} disabled={sending}
              className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-[#6B21A8] hover:bg-[#4C1D95] text-white font-semibold py-3 rounded-xl transition-colors active:scale-[0.98] disabled:opacity-60">
              {sending ? <Loader2 className="animate-spin" size={18} /> : "Request larger team"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
